import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Meetings from "../pages/meetings/page";
import Dues from "../pages/dues/page";
import Subscribe from "../pages/subscribe/page";
import Signup from "../pages/signup/page";
import Documents from "../pages/documents/page";
import QA from "../pages/qa/page";
import Profile from "../pages/profile/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/meetings",
    element: <Meetings />,
  },
  {
    path: "/dues",
    element: <Dues />,
  },
  {
    path: "/subscribe",
    element: <Subscribe />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/documents",
    element: <Documents />,
  },
  {
    path: "/qa",
    element: <QA />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
